import * as React from 'react';

import type { WorkOrderTableViewModel } from 'ab-viewModels/workOrderTable.viewModel';

import type TableNameEnum from 'ab-enums/tableName.enum';

import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import Breadcrumbs from 'af-components/Breadcrumbs';

import styles from './styles.module.scss';
import RelatedWorkOrders from '../../Shared/RelatedWorkOrders';

interface OwnProps {
	companyName: string;
	tableName: TableNameEnum;
	csvName: string;
	findRelatedWorkOrders: (tableRequestModel: TableQuery, startDate: Date, endDate: Date) => Promise<TableResult<WorkOrderTableViewModel>>;
}

type Props = OwnProps;

const ResourceWorkOrders: React.FC<Props> = (props) => {
	const { findRelatedWorkOrders, companyName, tableName, csvName } = props;

	return (
		<div className={styles['work-orders-container']}>
			<Breadcrumbs items={[{ label: 'Related Work Orders' }]} />
			<RelatedWorkOrders
				companyName={companyName}
				csvName={csvName}
				fetchWorkOrders={findRelatedWorkOrders}
				tableName={tableName}
			/>
		</div>
	);
};

export default React.memo(ResourceWorkOrders);
